import Input from '../../components/reusable/Input';
import produce from 'immer';
// import TextField from '@mui/material/TextField';
import _ from 'lodash';
import FilterSelect from '../../components/reusable/FilterSelect';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/HighlightOff';

import { DATE_TYPE, EXACT_TYPE, DROPDOWN_TYPE, RANGE_TYPE, TYPE, VAR, VALUE1, VALUE2 } from './constants';

function FilterForm({ index, onFilterValChange, arrOFilters, configuration, onRemoveFilter, highlighted, menuProps }) {
  const conf = configuration;
  const selectedField = arrOFilters[index].var;
  const seenFields = new Set();
  const fieldEntries = Object.values(conf || {})
    .flatMap((fields) => Object.entries(fields || {}))
    .filter(([field]) => {
      if (seenFields.has(field)) return false;
      seenFields.add(field);
      return true;
    });
  const fieldChoices = transformFilterChoices(fieldEntries);
  const typeChoices = transformFilterChoices(Object.keys(conf || {}).filter((type) => conf[type]?.[selectedField]));

  const checkForVariableType = (choiceType, variable) => {
    const returnVal = conf?.[choiceType]?.[variable]?.valType;
    return returnVal;
  };

  const returnExactOption = (choices) => {
    const fieldConfiguration = choices[arrOFilters[index].var] || {};
    return (
      <>
        {fieldConfiguration.valType === DATE_TYPE ? (
          <div className="filterControl filterValueControl">
            <div className="filterFieldLabel">Value</div>
            <Input
              variant="outlined"
              className="filterInput filterDateInput"
              value={_.get(arrOFilters, '[' + index + '].value1', -1)}
              max={_.get(arrOFilters, '[' + index + '].value2', -1)}
              onChange={(e) => {
                onFilterValChange(index, e, 'value1');
              }}
              type="datetime-local"
            />
          </div>
        ) : fieldConfiguration.valType === 'select' && Array.isArray(fieldConfiguration.options) ? (
          <div className="filterControl filterValueControl">
            <FilterSelect
              MenuProps={menuProps}
              label={fieldConfiguration.label || 'Value'}
              value={renderValue(fieldConfiguration.options, arrOFilters[index].value1)}
              options={fieldConfiguration.options}
              onChange={(value) => onFilterValChange(index, value, VALUE1)}
              clearable={true}
              searchable={false}
              key={`exact-value-${index}-${arrOFilters[index].var}`}
            />
          </div>
        ) : (
          <div className="filterControl filterValueControl">
            <Input
              variant="outlined"
              label="Value"
              className={'filterInput'}
              value={arrOFilters[index].value1}
              onChange={(value) => onFilterValChange(index, value, 'value1')}
              type={fieldConfiguration.valType === 'number' ? 'number' : undefined}
            />
          </div>
        )}
      </>
    );
  };

  const returnRangeOption = () => {
    const valueType = checkForVariableType(RANGE_TYPE, arrOFilters[index].var);
    return (
      <>
        {valueType === DATE_TYPE ? (
          <div className="filterRangeValues">
            <div className="filterControl filterValueControl">
              <Input
                label="From"
                variant="outlined"
                className="filterInput filterDateInput"
                value={_.get(arrOFilters, '[' + index + '].value1', -1)}
                max={_.get(arrOFilters, '[' + index + '].value2', -1)}
                onChange={(e) => {
                  onFilterValChange(index, e, 'value1');
                }}
                type="datetime-local"
              />
            </div>
            <div className="filterControl filterValueControl">
              <Input
                label="To"
                variant="outlined"
                className="filterInput filterDateInput"
                value={_.get(arrOFilters, '[' + index + '].value2', -1)}
                min={_.get(arrOFilters, '[' + index + '].value1', -1)}
                onChange={(e) => {
                  onFilterValChange(index, e, 'value2');
                }}
                type="datetime-local"
              />
            </div>
          </div>
        ) : (
          <div className="filterRangeValues">
            <Input
              variant="outlined"
              label="From"
              className={'filterInput'}
              value={arrOFilters[index].value1}
              onChange={(value) => onFilterValChange(index, value, 'value1')}
              type={valueType === 'number' ? 'number' : undefined}
            />
            <Input
              variant="outlined"
              label="To"
              className={'filterInput'}
              value={arrOFilters[index].value2}
              onChange={(value) => onFilterValChange(index, value, 'value2')}
              type={valueType === 'number' ? 'number' : undefined}
            />
          </div>
        )}
      </>
    );
  };

  const returnDropdownOption = (dropdownFieldConfigurations) => {
    const selectedFieldKey = arrOFilters[index].var;
    const specificDropdownConfig = dropdownFieldConfigurations[selectedFieldKey];

    let valueDropdownComponent;

    if (selectedFieldKey && specificDropdownConfig && Array.isArray(specificDropdownConfig.options)) {
      valueDropdownComponent = (
        <FilterSelect
          MenuProps={menuProps}
          label={specificDropdownConfig.label || 'Value'}
          variant="outlined"
          className={'muiselect filterSelectValue'}
          value={renderValue(specificDropdownConfig.options, arrOFilters[index].value1)}
          options={specificDropdownConfig.options}
          onChange={(selectedOption) => {
            onFilterValChange(index, selectedOption, VALUE1);
          }}
          clearable={true}
          searchable={false}
          key={`dropdown-value-${index}-${selectedFieldKey}`}
        />
      );
    } else if (selectedFieldKey) {
      valueDropdownComponent = <div className="filterHint filterHintError">&apos;{selectedFieldKey}&apos; is not set up for dropdown filtering or options are missing.</div>;
    } else {
      valueDropdownComponent = <div className="filterHint">Select a field.</div>;
    }

    return <div className="filterControl filterValueControl">{valueDropdownComponent}</div>;
  };

  return conf ? (
    <div className={`FilterForm filterRow${highlighted ? ' filterRowHighlighted' : ''}`}>
      <div className="filterControl filterFieldControl">
        <FilterSelect
          MenuProps={menuProps}
          label={'Filter by'}
          variant="outlined"
          className={'muiselect filterSelect'}
          value={renderValue(fieldChoices, selectedField)}
          options={fieldChoices}
          onChange={(value) => onFilterValChange(index, value, VAR)}
          clearable={false}
          searchable={false}
          key={`styled-select-var-${index}`}
        />
      </div>
      {selectedField && (
        <div className="filterControl filterTypeControl">
          <FilterSelect
            MenuProps={menuProps}
            label={'Filter type'}
            variant="outlined"
            className={'muiselect filterSelect'}
            value={renderValue(typeChoices, arrOFilters[index].type)}
            options={typeChoices}
            onChange={(value) => onFilterValChange(index, value, TYPE)}
            clearable={true}
            searchable={false}
            key={`styled-select-type-${index}`}
          />
        </div>
      )}
      {arrOFilters[index].type === RANGE_TYPE
        ? returnRangeOption()
        : arrOFilters[index].type === EXACT_TYPE
        ? returnExactOption(conf[EXACT_TYPE])
        : arrOFilters[index].type === DROPDOWN_TYPE
        ? returnDropdownOption(conf[DROPDOWN_TYPE])
        : null}
      <IconButton className="filterRemoveButton" size="small" onClick={() => onRemoveFilter(index)} aria-label="Remove filter">
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  ) : null;
}

function renderValue(choices, selected) {
  for (const choice in choices) {
    if (selected === choices[choice].value) {
      return choices[choice];
    }
  }
}

function transformFilterChoices(choices) {
  const opts = [];
  if (choices == null) {
    return opts;
  }

  choices.map((item) => {
    if (typeof item === 'string') {
      // za 'exact' in 'range' filter type
      opts.push({
        value: item,
        label: item
      });
    } else {
      // za filtrirne spremenljivke (id, orderNumber, itd.)
      opts.push({
        value: item[0],
        label: item[1]?.label ?? item[0]
      });
    }
  });

  return opts;
}

export default function listFilters(setArrOFilters, arrOFilters, filtersConf, highlightedFilterId, menuProps) {
  function onFilterValChange(index, value, type) {
    setArrOFilters((prevNewState) =>
      produce(prevNewState, (draft) => {
        const selectedValue = typeof value === 'object' ? value.value : value;
        draft[index][type] = selectedValue;
        if (type === VAR) {
          const supportedTypes = Object.keys(filtersConf || {}).filter((filterType) => filtersConf[filterType]?.[selectedValue]);
          draft[index][TYPE] = supportedTypes.length === 1 ? supportedTypes[0] : '';
        }
        if (type === VAR || type === TYPE) {
          draft[index][VALUE1] = '';
          draft[index][VALUE2] = '';
        }
      })
    );
  }

  function removeFilterRow(index) {
    setArrOFilters((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.splice(index, 1);
      })
    );
  }

  return (
    <div className="filtersDiv">
      {arrOFilters.map((item, index) => (
        <FilterForm
          index={index}
          arrOFilters={arrOFilters}
          onFilterValChange={onFilterValChange}
          onRemoveFilter={removeFilterRow}
          key={`FilterForm-${item.id ?? index}`}
          configuration={filtersConf}
          highlighted={item.id === highlightedFilterId}
          menuProps={menuProps}
        />
      ))}
    </div>
  );
}
